import { useState } from "react";
import { useNavigate } from "react-router-dom";
import logoutUser from "../api/logoutUser";
import { useAuth } from "../context/AuthContext";

export default function useLogout() {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const navigate = useNavigate();
  const { clearAuthenticatedSession } = useAuth();

  const handleLogout = async (options = {}) => {
    const { onBeforeRedirect } = options;

    if (isLoggingOut) return;

    setIsLoggingOut(true);

    try {
      await logoutUser();
    } catch (error) {
      console.error("Logout API error:", error);
    } finally {
      clearAuthenticatedSession();

      if (typeof onBeforeRedirect === "function") {
        onBeforeRedirect();
      }

      navigate("/");
      setIsLoggingOut(false);
    }
  };

  return {
    handleLogout,
    isLoggingOut,
  };
}